import { Injectable, Injector } from "@angular/core";
import { constants } from "src/app/config/constant";
import { SignalrService } from "../signalr.service";
import { ModuleService } from "./ModuleService";

@Injectable({
  providedIn: 'root'
})

export class IOModuleService extends ModuleService {

  constructor(public injector: Injector) {
    super("IO_Module", injector)
    this.logger.log('IO_Module constructor')
  }

  public turnModuleOn(moduleId: number) {
    return this.turnOutputDevice(true, moduleId)
  }

  public turnModuleOff(moduleId: number) {
    return this.turnOutputDevice(false, moduleId)
  }

  public turnOutputDevice(toggle: boolean, moduleId: number): Promise<any> {
    let method = toggle ? 'iOModule_TurnOnOutputDevice' : 'iOModule_TurnOffOutputDevice'
    return this.callMethod(method, moduleId)
  }

}
